export const forceRedirectToHttps = () => {
    if (window.location.protocol !== 'https:' &&
        !window.location.href.startsWith('http://localhost') &&
        !window.location.href.startsWith('http://127.0.0.1') &&
        !window.location.href.startsWith('http://ai-hayden-staticweb')) {
        window.location.protocol = 'https:';
    }
}
